import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_functioning_lockout_tagout_program_machinery_equip_applicable'

export const dataPointDefinition = {
  retracedId: 'no_functioning_lockout_tagout_program_machinery_equip_applicable',
  name: 'No functioning lockout/tagout program for machinery and equipment (if applicable)',
  description:
    'A lockout/tagout program includes, at minimum, regular, documented monitoring processes for lockout/tagout (LOTO) procedures, lockout/tagout equipment (e.g., tags, group lock boxes), and training procedures for all workers.',
  meta: {
    slcpMeta: {
      key: 'hs-wor-33x',
      number: 'HS-WOR-18-1',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-wor-33x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31760,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
